const BeforeAfterComparison = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="M35.5137 36.3692V38.9175C35.5137 39.6065 36.0827 40.1653 36.7841 40.1653H41.8358C42.5372 40.1653 43.1059 39.6066 43.1059 38.9175V25.8794C43.1059 24.9565 42.8834 24.0707 42.48 23.2834L41.33 21.7474L44.2039 20.1987C44.851 19.8494 45.1755 18.7209 44.9121 17.7348L44.6175 16.6311C44.4331 15.9406 44.0005 15.491 43.5212 15.491H37.5322L36.4097 12.3247C35.8729 10.8095 34.4393 9.79688 32.832 9.79688H28.8709C28.3468 9.79688 27.9219 10.2218 27.9219 10.7459C27.9219 11.27 28.3468 11.6949 28.8709 11.6949H32.832C33.6358 11.6949 34.3524 12.201 34.6209 12.9589L35.7429 16.125C36.0117 16.8826 36.7283 17.389 37.5322 17.389H42.8555L43.0787 18.2243C43.1136 18.3557 43.1144 18.5157 43.0847 18.6456L40.4294 20.0764C39.2922 20.6892 39.0863 22.2347 40.0236 23.1241C40.7762 23.8382 41.2079 24.8314 41.2079 25.8793V38.2673H37.4118V36.3693C37.4118 35.321 36.5621 34.4713 35.5138 34.4713H28.871C28.3468 34.4713 27.922 34.8962 27.922 35.4203C27.922 35.9444 28.3468 36.3693 28.871 36.3693L35.5137 36.3692Z"
        fill="#B8CBFC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.8794 27.3862L36.9948 26.8776C37.2187 26.85 37.4049 27.0464 37.4049 27.2721V28.1187C37.4049 28.7198 36.9118 29.2295 36.3106 29.2524L32.1952 29.4054C32.0458 29.4114 31.9219 29.292 31.9219 29.143V28.3779C31.9219 27.8531 32.3563 27.4508 32.8794 27.3862Z"
        fill="#B8CBFC"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.1209 6C24.645 6 25.0699 6.52414 25.0699 6.94901V41.1139C25.0699 41.638 24.645 42.0629 24.1209 42.0629C23.5968 42.0629 23.1719 41.5387 23.1719 41.1139V6.94901C23.1719 6.42488 23.5968 6 24.1209 6Z"
        fill="#B8CBFC"
      />
      <path
        d="M19.1328 9.82031C19.6569 9.82031 20.0819 10.2455 20.082 10.7695C20.082 11.2937 20.6062 35.4443 20.082 35.4443C20.0819 35.9684 19.6569 36.3936 19.1328 36.3936L12.4902 36.3926V38.9414C12.4902 39.6304 11.9215 40.1894 11.2197 40.1895H6.16797C5.46659 40.1894 4.89751 39.6304 4.89746 38.9414V25.9033C4.89746 24.9805 5.12013 24.0945 5.52344 23.3076L6.67383 21.7715L3.7998 20.2227C3.15263 19.8732 2.8284 18.7447 3.0918 17.7588L3.38672 16.6553C3.57106 15.9649 4.00323 15.5148 4.48242 15.5146H10.4717L11.5938 12.3486C12.131 10.8334 13.5645 9.82031 15.1719 9.82031H19.1328ZM11.0957 26.9736C10.8719 26.9461 10.6857 27.1426 10.6855 27.3682V28.2148C10.6855 28.816 11.1791 29.3257 11.7803 29.3486L15.8955 29.502C16.0448 29.5078 16.1689 29.3882 16.1689 29.2393V28.4746C16.1689 27.9497 15.734 27.5471 15.2109 27.4824L11.0957 26.9736Z"
        fill="#2D65F2"
        fillOpacity="0.5"
      />
    </svg>
  );
};

export default BeforeAfterComparison;
